export default __webpack_public_path__ + "static/media/p_4.c3463b23.jpg";